import { useParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { Spinner, ErrorBox, PageHead, Initials } from "../components/common";

const TEAM = [
  ["Hazel Ostrander", "Executive Director", "A former studio manager who has fired more than 400 kiln loads and now runs the Guild's introductions programme."],
  ["Marcus Ibarra-Lowe", "Head of Member Programmes", "Leads events, studio circles and the resource library, with a background in ceramics education."],
  ["Odessa Finch", "Gallery & Collector Relations", "Works with partner galleries and collectors to open doors for emerging and established artists."],
];

export function CmsBody({ slug }) {
  const { data, loading, error } = useApi(`/pages/${slug}`);
  if (loading) return <Spinner />;
  if (error) return <ErrorBox message={error} />;
  return <div className="prose-kh max-w-3xl text-base md:text-lg" data-testid={`cms-page-${slug}`} dangerouslySetInnerHTML={{ __html: data.body_html }} />;
}

export default function About() {
  return (
    <div>
      <PageHead eyebrow="About" title="A guild built around the kiln" intro="Kilnhouse Guild is a membership network for independent ceramic artists, pottery studios, galleries and collectors." />
      <section className="kh-container grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7"><h2 className="mb-4 text-3xl">Our mission</h2><CmsBody slug="about" /></div>
        <img src="/img/p5.jpg" alt="Clay being shaped on a potter's wheel" className="aspect-[4/3] w-full rounded-[2rem] object-cover lg:col-span-5" />
      </section>
      <section className="kh-container mt-20" aria-labelledby="team-h">
        <h2 id="team-h" className="mb-8 text-3xl">Leadership team</h2>
        <div className="grid gap-6 md:grid-cols-3">
          {TEAM.map(([n, r, b]) => (
            <article key={n} className="kh-card p-6" data-testid="team-member-card">
              <Initials name={n} size="h-16 w-16 text-xl" />
              <h3 className="mt-4 text-xl">{n}</h3>
              <p className="text-sm font-medium text-celadon-dark">{r}</p>
              <p className="mt-3 text-sm text-[#4a4f59]">{b}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export function CmsPage() {
  const { slug } = useParams();
  const { data } = useApi(`/pages/${slug}`);
  return (
    <div>
      <PageHead title={data?.title || "…"} />
      <div className="kh-container"><CmsBody slug={slug} /></div>
    </div>
  );
}
